import styled from 'styled-components';
import device from '../../../components/mediaQueries';

const Title = styled.span`
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 13px;
  letter-spacing: 1px;
  color: #f25c5e;
  ${({ cursor }) => (cursor ? 'cursor: pointer;' : null)}
  ${device.mobile`
    line-height: 25px;
  `}
`;

export default Title;
